export default __webpack_public_path__ + "static/media/Twitter.d06834eb.svg";